module.exports = __webpack_public_path__ + "static/media/PillsImg23.9001b44b.jpg";